<template>

<div class="page" :class="{'is-success': hasSubscribed}">

    <div class="page-content">

        <div class="page-content-left">

            <div class="membership-head">

                <div class="membership-head-image" v-bgimage="organisation.logo">

                    <app-icon icon="organisation" v-if="!organisation.logo" />

                </div>

                <div class="membership-head-name">
                
                    <div class="membership-head-name-org">{{ organisation.name }}</div>
                    <div class="membership-head-name-mem">{{ membership.name }}</div>
                
                </div>

            </div>

            <div class="plans" :class="{'is-locked': is.paying || hasSubscribed}">

                <div class="plans-item" v-tooltip="(plan.id === selectedPlan.id) ? 'You have selected this plan' : 'Click to select plan'" :class="{'is-active': plan.id === selectedPlan.id}" v-for="plan in plans" :key="plan.id" v-on:click="onPlanClick(plan)">

                    <div class="plans-item-text">

                        <div class="plans-item-name">{{ plan.name }}</div>
                        <div class="plans-item-description">{{ plan.description }}</div>

                    </div>

                    <div class="plans-item-cost">
                        <div class="plans-item-cost-value">{{ plan.cost | formatMoney }}</div>
                        <div class="plans-item-cost-cycle">{{ $constants.membership.plan.cycleName[plan.cycle] }}</div>
                    </div>

                </div>

            </div>
        
        </div>

        <div class="page-content-right" v-if="hasSubscribed">

            <app-icon icon="tick" class="success-icon" />

            <div class="success-text">
                Thank you, {{ firstname }}! You will shortly receive an e-mail confirming your membership to {{ organisation.name }} {{ membership.name }} and your reference is #<b>{{ reference }}</b>.
            </div>

        </div>

        <div class="page-content-right" v-if="!hasSubscribed">

            <template v-if="!is.paying">

                <template v-for="input in inputs">

                    <app-input-text v-model="model[input.id]" :loading="is.inputloading === input.id" :key="input.id" :validation="$v.model[input.id]" :label="input.name" :locked="input.locked" :notes="input.description" v-if="input.type === $constants.membership.capture.type.textbox" />
                    
                    <app-input-image v-model="model[input.id]" :key="input.id"  :validation="$v.model[input.id]" :label="input.name" :notes="input.description" :allow-webcam="true" v-if="input.type === $constants.membership.capture.type.file && input.role === $constants.membership.capture.role.photo" />
                    
                    <app-input-file v-model="model[input.id]" :key="input.id" :validation="$v.model[input.id]" :label="input.name" :notes="input.description" accept="pdf,docx,jpg,png,gif,mp4,mp3"  v-if="input.type === $constants.membership.capture.type.file && input.role !== $constants.membership.capture.role.photo" />
                    
                    <app-input-select v-model="model[input.id]" :key="input.id" :validation="$v.model[input.id]" :label="input.name" :notes="input.description" placeholder="Select option" v-if="input.type === $constants.membership.capture.type.select" property="id" :options="input.options" />

                </template>

                <div class="form-buttons">

                    <app-button :disabled="!isValid" theme="blue" text="Continue" v-on:click="onContinueClick">

                        <app-icon icon="caret-right" />

                    </app-button>

                </div>

            </template>

            <template v-if="is.paying">

                <app-icon icon="loading" v-if="is.loading" class="payment-loading" />

                <stripe-element-payment v-on:error="onStripeError" v-on:element-ready="onStripeReady" ref="stripe" :pk="pk" :elements-options="options" :confirm-params="params" v-if="options.clientSecret && total" class="review-stripe" />

                <com-discount v-if="options.clientSecret && !is.loading" :intent="intentKey" v-on:discount="onDiscount" />

                <div class="form-buttons is-split" v-if="!is.loading">

                    <app-button theme="plain" text="Cancel" :disabled="is.completing" v-on:click="onCancelClick" />
                    <app-button theme="blue" :loading="is.completing" text="Complete" v-on:click="onCompleteClick" />

                </div>

            </template>
        
        </div>

    </div>
	
	<com-foot :force="true" />

</div>
	
</template>

<script>

import comFoot from './../../screen/Foot'
import comDiscount from './Discount'

import Vue from 'vue'

import { StripeElementPayment } from '@vue-stripe/vue-stripe'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'

export default {

	mixins: [validationMixin],
	
	components: {
        StripeElementPayment,
		'com-foot': comFoot,
        'com-discount': comDiscount
	},

    data: function() {
    
        return {
            model: {},
            selectedPlan: false,
            is: {
                paying: false,
                loading: false,
                completing: false,
                inputloading: false,
                subscribed: false
            },
            discount: 0,
            intentKey: '',
            errorMessage: false,
			pk: process.env.VUE_APP_STRIPE,
			testMode: true,
            validEmail: false,
            options: {
				appearance: {},
				clientSecret: false
			},
			params: {
				return_url: ''
			}
        }
    
    },

    validations: function() {

		var validations = {
			model: {}
		}

		this.$_.each(this.inputs, function(input) {

			Vue.set(validations.model, input.id, {})

			if (input.required) {

				Vue.set(validations.model[input.id], 'required', required)

			}

			if (input.role === this.$constants.membership.capture.role.email) {

				Vue.set(validations.model[input.id], 'email', email)

			}

		}.bind(this))

		return validations

	},

    created: function() {

        if (this.plans.length === 1) {
        
            Vue.set(this, 'selectedPlan', this.plans[0])

        }

        this.params.return_url = process.env.VUE_APP_CALLBACK + this.$store.getters['join/onboarding'].url

        this.$_.each(this.inputs, function(input) {
        
            var defaultValue = ''

			if (input.type === this.$constants.membership.capture.type.checkbox || input.type === this.$constants.membership.capture.type.select) {

				defaultValue = 0

			}

            if (input.role === this.$constants.membership.capture.role.email) {

                if (this.$route.query.email) {

                    defaultValue = this.$route.query.email
                    input.locked = true

                }

            } else if (input.role === this.$constants.membership.capture.role.firstname) {

                if (this.$route.query.firstname) {
                
                    defaultValue = this.$route.query.firstname
                    input.locked = true

                }

            } else if (input.role === this.$constants.membership.capture.role.lastname) {

                if (this.$route.query.lastname) {
                
                    defaultValue = this.$route.query.lastname
                    input.locked = true

                }

            }

			Vue.set(this.model, input.id, defaultValue)

        }.bind(this))

        if (this.$store.getters['join/status']) {
        
            this.$_.each(this.$store.getters['join/capture'], function(value, key) {

                Vue.set(this.model, key, value)

            }.bind(this))

            Vue.set(this, 'selectedPlan', this.$_.findWhere(this.plans, {
                id: this.$store.getters['join/plan']
            }))
    
        }

    },

    watch: {

        email: function(n) {

            this.validEmail = false

            if (!this.$v.model[this.emailID].$invalid) {
            
                this.is.inputloading = this.emailID
                
                this.$api.get('exists', {
                    onboarding: this.$store.getters['join/onboarding'].id,
                    email: n
                }).then(function(json) {
                
                    this.validEmail = !json.subscribed
                    this.is.subscribed = json.subscribed
                    this.is.inputloading = false
                
                }.bind(this))

            }
        
        }

    },

    computed: {

        total: function() {
        
            return this.selectedPlan.cost - this.discount

        },

        firstname: function() {

            return this.model[this.$_.findWhere(this.inputs, {
                role: this.$constants.membership.capture.role.firstname
            }).id]

        },

        emailID: function() {

            return this.$_.findWhere(this.inputs, {
                role: this.$constants.membership.capture.role.email
            }).id

        },

        email: function() {

            return this.model[this.$_.findWhere(this.inputs, {
                role: this.$constants.membership.capture.role.email
            }).id]

        },

        reference: function() {
        
            return this.$store.getters['join/reference']

        },

        hasSubscribed: function() {
        
            return this.$store.getters['join/status'] === this.$constants.registration.payment.success
        
        },

        organisation: function() {

            return this.$store.getters['join/organisation']
        
        },

        membership: function() {

            return this.$store.getters['join/membership']
        
        },
    
        plans: function() {
        
            return this.$store.getters['join/plans']
        
        },
    
        inputs: function() {
        
            return this.$store.getters['join/inputs']
        
        },

        isValid: function() {

			return !this.$v.$invalid && this.selectedPlan && this.validEmail

		}
    
    },

    methods: {

        onDiscount: function(value) {

			this.discount = value

		},

		onCompleteClick: function() {

			this.errorMessage = false
            this.is.completing = true

			if (this.options.clientSecret && this.total) {

				this.$refs.stripe.submit()

			} else {

				this.$api.put('intent', {
					intent: this.intentKey
				}).then(function(json) {

                    this.$store.commit('join/status', json.status)
                    this.$store.commit('join/reference', json.reference)
                    this.$store.commit('join/capture', json.data.capture)
                    this.$store.commit('join/plan', json.data.plan)

                    this.is.completing = false

				}.bind(this), function() {

					this.errorMessage = 'Sorry, there was a problem completing your purchase. We\'re working hard to resolve it. Please try again later today.'
                
                    this.is.completing = false

				}.bind(this))

			}

		},

        onCancelClick: function() {

            this.options.clientSecret = false
            this.intentKey = ''

            this.is.paying = false

        },

        onStripeReady: function() {

			this.is.loading = false

		},

		onStripeError: function(e) {

			this.errorMessage = e.message

			this.is.loading = false
            this.is.completing = false

		},

        onContinueClick: function() {

            this.errorMessage = ''

            this.is.paying = true
            this.is.loading = true

            this.$api.post('intent', {
                onboarding: this.$store.getters['join/onboarding'].id,
                data: {
                    plan: this.selectedPlan.id,
                    capture: this.model
                }
            }).then(function(json) {

                this.intentKey = json.intent

                if (json.clientSecret) {

                    this.options.clientSecret = json.clientSecret

                } else {

                    this.is.loading = false

                }

            }.bind(this), function() {

                this.errorMessage = 'Sorry, there was a problem communicating with the payment gateway. We\'re working hard to resolve it. Please try again later today.'
                
                this.is.loading = false

            }.bind(this))

        },
    
        onPlanClick: function(plan) {

            if (!this.is.paying) {
        
                this.selectedPlan = plan
                
            }
        
        }
    
    }

}

</script>

<style scoped>

.page {
	width: 100%;
    height: calc(100vh - 32px);
}

.is-mobile .page {
    height: auto;
}

.page-content {
    position: absolute;
    left: 0px;
    right: 0px;
    top: 0px;
    width: 100%;
    bottom: 0px;
    display: grid;
    grid-template-columns: 50% 50%;
    grid-template-rows: 1fr;
}

.is-mobile .page-content {
    position: relative;
    left: auto;
    right: auto;
    top: auto;
    bottom: auto;
    display: block;
}

.page-content-left {
    background-color: #4d5b6e;
    padding-left: calc(50vw - 480px);
    padding-right: 40px;
    padding-top: 40px;
}

.is-mobile .page-content-left {
    padding: 20px 20px 1px 20px;
}

.page.is-success .page-content-left {
	background-color: #4faa80;
}

.membership-head {
    height: 96px;
    display: flex;
    align-items: center;
    margin-bottom: 40px;
}

.is-mobile .membership-head {
    height: 64px;
    margin-bottom: 20px;
}

.membership-head-image {
    width: 96px;
    height: 96px;
    background-color: #fff;
    border-radius: 10px;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: contain;
    margin-right: 20px;
    font-size: 64px;
    text-align: center;
    line-height: 96px;
    color: #ffbe7a;
}

.is-mobile .membership-head-image {
    width: 64px;
    height: 64px;
    line-height: 64px;
    font-size: 40px;
}

.membership-head-name-org {
    font-size: 20px;
    color: #fff;
    opacity: 0.8;
    font-weight: 300;
}

.is-mobile .membership-head-name-org {
    font-size: 16px;
}

.membership-head-name-mem {
    font-size: 40px;
    font-weight: 500;
    color: #fff;
    flex-grow: 1;
}

.is-mobile .membership-head-name-mem {
    font-size: 32px;
}

.plans {
    margin-left: -20px;
    margin-right: -20px;
    width: calc(100% + 40px);
}

.is-mobile .plans {
    margin: 0px;
    width: 100%;
}

.plans.is-locked {
    pointer-events: none;
}

.plans-item {
    background-color: #374353;
    border-radius: 10px;
    margin-bottom: 20px;
    color: #fff;
    min-height: 100px;
    display: flex;
    z-index: 1;
    cursor: pointer;
    user-select: none;
}

.is-mobile .plans-item {
    min-height: 64px;
}

.page.is-success .plans-item:not(.is-active) {
    display: none;
}

.is-desktop .plans-item:not(.is-active):hover {
    background-color: #252e39;
}

.plans-item.is-active {
    background-color: #ffbe7a;
    color: #4d5b6e;
}

.page.is-success .plans-item.is-active {
    background-color: #2c694d;
    color: #fff;
}

.plans-item.is-active:after {
    content: '';
    display: block;
    position: absolute;
    right: -20px;
    top: 50%;
    margin-top: -20px;
    border-style: solid;
    border-width: 20px 0 20px 20px;
    border-color: transparent transparent transparent #FFBE7A;
    transform: rotate(0deg);
}

.is-mobile .plans-item.is-active:after {
    display: none;
}

.page.is-success .plans-item.is-active:after {
    border-color: transparent transparent transparent #2c694d;
}

.plans-item-text {
    flex-grow: 1;
    padding: 20px;
}

.is-mobile .plans-item-text {
    padding: 10px;
}

.plans-item-name {
    font-size: 20px;
    margin-bottom: 4px;
    font-weight: 500;
}

.is-mobile .plans-item-name {
    font-size: 16px;
}

.plans-item-description {
    font-size: 16px;
    line-height: 20px;
    font-weight: 300;
}

.is-mobile .plans-item-description {
    font-size: 14px;
}

.plans-item-cost {
    width: 160px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border-left: 1px solid #4d5b6e;
}

.is-mobile .plans-item-cost {
    width: 100px;
}

.plans-item-cost-value {
    font-weight: 700;
    font-size: 32px;
}

.is-mobile .plans-item-cost-value {
    font-size: 20px;
}

.plans-item-cost-cycle {
    font-weight: 300;
    font-size: 16px;
    margin-top: 2px;
}

.is-mobile .plans-item-cost-cycle {
    font-size: 14px;
}

.page-content-right {
    background-color: #fff;
    padding-left: 40px;
    padding-right: calc(50vw - 480px);
    padding-top: 190px;
}

.is-mobile .page-content-right {
    padding: 20px 20px 0px 20px;
    min-height: 128px;
}

.page-content-right h1 {
    font-size: 32px;
    color: #687589;
    line-height: 40px;
    margin-bottom: 20px;
}

.page-content-right p {
    font-size: 14px;
    color: #687589;
    line-height: 16px;
    margin-bottom: 40px;
}

.form-buttons {
    margin-top: 20px;
    display: flex;
    width: 100%;
    justify-content: flex-end;
}

.form-buttons.is-split {
    justify-content: space-between;
}

.form-buttons >>> .button {
    margin: 0px;
    display: flex;
    justify-content: center;
}

.form-buttons.is-split >>> .button:first-child {
    border: 1px solid #236dc9;
    box-sizing: border-box;
    color: #236dc9;
}

.form-buttons.is-split >>> .button:first-child:hover {
    background-color: #236dc9;
    color: #fff;
}

.form-buttons:not(.is-split) >>> .button .icon {
    margin-left: 10px;
}

.payment-loading {
    position: absolute;
    left: 240px;
    top: 50%;
    font-size: 48px;
    color: #ffbe7a;
}

.is-mobile .payment-loading {
    left: 50%;
    transform: translate(-50%, -50%);
}

.success-icon {
    font-size: 96px;
    margin-bottom: 40px;
	color: #4faa80;
}

.success-text {
    color: #687589;
    font-size: 20px;
    font-weight: 400;
    line-height: 28px;
}

.subscribed {
	background-color: #c55b5b;
    color: #fff;
    font-weight: 300;
    margin-left: 150px;
    font-size: 14px;
    line-height: 18px;
    padding: 8px 10px;
    border-radius: 10px;
    margin-bottom: 10px;
}

.is-mobile .subscribed {
    margin-left: 0px;
}

.subscribed:after {
    content: '';
    display: block;
    position: absolute;
    left: 10px;
    top: -10px;
    border-style: solid;
    border-width: 0 10px 10px 10px;
    border-color: transparent transparent #c55b5b transparent;
    transform: rotate(0deg);
}

</style>